export default "__VITE_ASSET__68aefc9b__"